import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Box"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 2.25H3C2.17157 2.25 1.5 2.92157 1.5 3.75V6.75C1.5 7.57843 2.17157 8.25 3 8.25V20.25C3 21.0784 3.67157 21.75 4.5 21.75H19.5C20.3284 21.75 21 21.0784 21 20.25V8.25C21.8284 8.25 22.5 7.57843 22.5 6.75V3.75C22.5 2.92157 21.8284 2.25 21 2.25ZM19.5 20.25H4.5V8.25H19.5V20.25ZM3 6.75H21V3.75H3V6.75ZM15 15.75H9C8.17157 15.75 7.5 15.0784 7.5 14.25V12.75C7.5 11.9216 8.17157 11.25 9 11.25H15C15.8284 11.25 16.5 11.9216 16.5 12.75V14.25C16.5 15.0784 15.8284 15.75 15 15.75ZM9 14.25V12.75H15V14.25H9Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Box.vue"]]);
